var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileOpenAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.06,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8055 11.4559C17.9123 11.5063 17.9804 11.6138 17.9804 11.7319V16.4997C17.9804 16.7236 17.7475 16.8712 17.545 16.7757L9.0447 12.7648C8.93789 12.7144 8.86975 12.6069 8.86975 12.4888V7.72095C8.86975 7.49711 9.10273 7.34943 9.30516 7.44495L17.8055 11.4559Z",
    fill: "#008440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6946 7.4067C26.897 7.3107 27.1305 7.45837 27.1305 7.68245V12.411C27.1305 12.5285 27.063 12.6356 26.957 12.6863L18.4172 16.7721C18.2147 16.869 17.9803 16.7214 17.9803 16.4968V11.7315C17.9803 11.6136 18.0483 11.5062 18.1548 11.4557L26.6946 7.4067Z",
    fill: "#28A864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8068 21.4336C17.9129 21.4843 17.9804 21.5914 17.9804 21.7089V26.8804C17.9804 26.8986 17.9613 26.9105 17.945 26.9026L13.6953 24.8342C13.5903 24.783 13.5237 24.6765 13.5237 24.5598V19.8708C13.5237 19.6464 13.7579 19.4987 13.9604 19.5955L17.8068 21.4336Z",
    fill: "#008440"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9984 19.5609C22.2011 19.4622 22.4371 19.6098 22.4371 19.8353V24.5203C22.4371 24.6371 22.3705 24.7436 22.2655 24.7947L18.4191 26.6668C18.2164 26.7655 17.9803 26.6179 17.9803 26.3924V21.7074C17.9803 21.5906 18.047 21.4841 18.152 21.433L21.9984 19.5609Z",
    fill: "#28A864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2475 9.06058H17.7132C17.3761 9.06058 17.1028 9.33384 17.1028 9.67093V29.0896C17.1028 29.4267 17.3761 29.7 17.7132 29.7H18.2475C18.5845 29.7 18.8578 29.4267 18.8578 29.0896V9.67093C18.8578 9.33384 18.5845 9.06058 18.2475 9.06058Z",
    fill: "#008440"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.06,
    stroke: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOpenAppIcon);
export default __webpack_public_path__ + "static/media/mobile-open-app-icon.668a0836fc853025d6f5827faa273786.svg";
export { ForwardRef as ReactComponent };